import { NodeProp as F } from "./ghl-ui.es425.js";
let z = 0;
class k {
  /**
  @internal
  */
  constructor(t, a, i) {
    this.set = t, this.base = a, this.modified = i, this.id = z++;
  }
  /**
  Define a new tag. If `parent` is given, the tag is treated as a
  sub-tag of that parent, and
  [highlighters](#highlight.tagHighlighter) that don't mention
  this tag will try to fall back to the parent tag (or grandparent
  tag, etc).
  */
  static define(t) {
    if (t != null && t.base)
      throw new Error("Can not derive from a modified tag");
    let a = new k([], null, []);
    if (a.set.push(a), t)
      for (let i of t.set)
        a.set.push(i);
    return a;
  }
  /**
  Define a tag _modifier_, which is a function that, given a tag,
  will return a tag that is a subtag of the original. Applying the
  same modifier to a twice tag will return the same value (`m1(t1)
  == m1(t1)`) and applying multiple modifiers will, regardless or
  order, produce the same tag (`m1(m2(t1)) == m2(m1(t1))`).
  
  When multiple modifiers are applied to a given base tag, each
  smaller set of modifiers is registered as a parent, so that for
  example `m1(m2(m3(t1)))` is a subtype of `m1(m2(t1))`,
  `m1(m3(t1)`, and so on.
  */
  static defineModifier() {
    let t = new C();
    return (a) => a.modified.indexOf(t) > -1 ? a : C.get(a.base || a, a.modified.concat(t).sort((i, l) => i.id - l.id));
  }
}
let G = 0;
class C {
  constructor() {
    this.instances = [], this.id = G++;
  }
  static get(t, a) {
    if (!a.length)
      return t;
    let i = a[0].instances.find((r) => r.base == t && L(a, r.modified));
    if (i)
      return i;
    let l = [], s = new k(l, t, a);
    for (let r of a)
      r.instances.push(s);
    let g = Q(a);
    for (let r of t.set)
      if (!r.modified.length)
        for (let d of g)
          l.push(C.get(r, d));
    return s;
  }
}
function L(o, t) {
  return o.length == t.length && o.every((a, i) => a == t[i]);
}
function Q(o) {
  let t = [[]];
  for (let a = 0; a < o.length; a++)
    for (let i = 0, l = t.length; i < l; i++)
      t.push(t[i].concat(o[a]));
  return t.sort((a, i) => i.length - a.length);
}
function $(o) {
  let t = /* @__PURE__ */ Object.create(null);
  for (let a in o) {
    let i = o[a];
    Array.isArray(i) || (i = [i]);
    for (let l of a.split(" "))
      if (l) {
        let s = [], g = 2, r = l;
        for (let f = 0; ; ) {
          if (r == "..." && f > 0 && f + 3 == l.length) {
            g = 1;
            break;
          }
          let c = /^"(?:[^"\\]|\\.)*?"|[^\/!]+/.exec(r);
          if (!c)
            throw new RangeError("Invalid path: " + l);
          if (s.push(c[0] == "*" ? "" : c[0][0] == '"' ? JSON.parse(c[0]) : c[0]), f += c[0].length, f == l.length)
            break;
          let N = l[f++];
          if (f == l.length && N == "!") {
            g = 0;
            break;
          }
          if (N != "/")
            throw new RangeError("Invalid path: " + l);
          r = l.slice(f);
        }
        let d = s.length - 1, h = s[d];
        if (!h)
          throw new RangeError("Invalid path: " + l);
        let v = new q(i, g, d > 0 ? s.slice(0, d) : null);
        t[h] = v.sort(t[h]);
      }
  }
  return J.add(t);
}
const J = new F();
class q {
  constructor(t, a, i, l) {
    this.tags = t, this.mode = a, this.context = i, this.next = l;
  }
  get opaque() {
    return this.mode == 0;
  }
  get inherit() {
    return this.mode == 1;
  }
  sort(t) {
    return !t || t.depth < this.depth ? (this.next = t, this) : (t.next = this.sort(t.next), t);
  }
  get depth() {
    return this.context ? this.context.length : 0;
  }
}
q.empty = new q([], 2, null);
function U(o, t) {
  let a = /* @__PURE__ */ Object.create(null);
  for (let s of o)
    if (!Array.isArray(s.tag))
      a[s.tag.id] = s.class;
    else
      for (let g of s.tag)
        a[g.id] = s.class;
  let { scope: i, all: l = null } = t || {};
  return {
    style: (s) => {
      let g = l;
      for (let r of s)
        for (let d of r.set) {
          let h = a[d.id];
          if (h) {
            g = g ? g + " " + h : h;
            break;
          }
        }
      return g;
    },
    scope: i
  };
}
function W(o, t) {
  let a = null;
  for (let i of o) {
    let l = i.style(t);
    l && (a = a ? a + " " + l : l);
  }
  return a;
}
function _(o, t, a, i = 0, l = o.length) {
  let s = new X(i, Array.isArray(t) ? t : [t], a);
  s.highlightRange(o.cursor(), i, l, "", s.highlighters), s.flush(l);
}
class X {
  constructor(t, a, i) {
    this.at = t, this.highlighters = a, this.span = i, this.class = "";
  }
  startSpan(t, a) {
    a != this.class && (this.flush(t), t > this.at && (this.at = t), this.class = a);
  }
  flush(t) {
    t > this.at && this.class && this.span(this.at, t, this.class);
  }
  highlightRange(t, a, i, l, s) {
    let { type: g, from: r, to: d } = t;
    if (r >= i || d <= a)
      return;
    g.isTop && (s = this.highlighters.filter((N) => !N.scope || N.scope(g)));
    let h = l, v = Y(t) || q.empty, f = W(s, v.tags);
    if (f && (h && (h += " "), h += f, v.mode == 1 && (l += (l ? " " : "") + f)), this.startSpan(Math.max(a, r), h), v.opaque)
      return;
    let c = t.tree && t.tree.prop(F.mounted);
    if (c && c.overlay) {
      let N = t.node.enter(c.overlay[0].from + r, 1), V = this.highlighters.filter((x) => !x.scope || x.scope(c.tree.type)), B = t.firstChild();
      for (let x = 0, M = r; ; x++) {
        let O = x < c.overlay.length ? c.overlay[x] : null, E = O ? O.from + r : d, H = Math.max(a, M), R = Math.min(i, E);
        if (H < R && B)
          for (; t.from < R && (this.highlightRange(t, H, R, l, s), this.startSpan(Math.min(R, t.to), h), !(t.to >= E || !t.nextSibling())); )
            ;
        if (!O || E > i)
          break;
        M = O.to + r, M > a && (this.highlightRange(N.cursor(), Math.max(a, O.from + r), Math.min(i, M), "", V), this.startSpan(Math.min(i, M), h));
      }
      B && t.parent();
    } else if (t.firstChild()) {
      c && (l = "");
      do
        if (!(t.to <= a)) {
          if (t.from >= i)
            break;
          this.highlightRange(t, a, i, l, s), this.startSpan(Math.min(i, t.to), h);
        }
      while (t.nextSibling());
      t.parent();
    }
  }
}
function Y(o) {
  let t = o.type.prop(J);
  for (; t && t.context && !o.matchContext(t.context); )
    t = t.next;
  return t || null;
}
const e = k.define, A = e(), y = e(), P = e(y), D = e(y), b = e(), T = e(b), K = e(b), u = e(), w = e(u), p = e(), m = e(), j = e(), S = e(j), I = e(), n = {
  /**
  A comment.
  */
  comment: A,
  /**
  A line [comment](#highlight.tags.comment).
  */
  lineComment: e(A),
  /**
  A block [comment](#highlight.tags.comment).
  */
  blockComment: e(A),
  /**
  A documentation [comment](#highlight.tags.comment).
  */
  docComment: e(A),
  /**
  Any kind of identifier.
  */
  name: y,
  /**
  The [name](#highlight.tags.name) of a variable.
  */
  variableName: e(y),
  /**
  A type [name](#highlight.tags.name).
  */
  typeName: P,
  /**
  A tag name (subtag of [`typeName`](#highlight.tags.typeName)).
  */
  tagName: e(P),
  /**
  A property or field [name](#highlight.tags.name).
  */
  propertyName: D,
  /**
  An attribute name (subtag of [`propertyName`](#highlight.tags.propertyName)).
  */
  attributeName: e(D),
  /**
  The [name](#highlight.tags.name) of a class.
  */
  className: e(y),
  /**
  A label [name](#highlight.tags.name).
  */
  labelName: e(y),
  /**
  A namespace [name](#highlight.tags.name).
  */
  namespace: e(y),
  /**
  The [name](#highlight.tags.name) of a macro.
  */
  macroName: e(y),
  /**
  A literal value.
  */
  literal: b,
  /**
  A string [literal](#highlight.tags.literal).
  */
  string: T,
  /**
  A documentation [string](#highlight.tags.string).
  */
  docString: e(T),
  /**
  A character literal (subtag of [string](#highlight.tags.string)).
  */
  character: e(T),
  /**
  An attribute value (subtag of [string](#highlight.tags.string)).
  */
  attributeValue: e(T),
  /**
  A number [literal](#highlight.tags.literal).
  */
  number: K,
  /**
  An integer [number](#highlight.tags.number) literal.
  */
  integer: e(K),
  /**
  A floating-point [number](#highlight.tags.number) literal.
  */
  float: e(K),
  /**
  A boolean [literal](#highlight.tags.literal).
  */
  bool: e(b),
  /**
  Regular expression [literal](#highlight.tags.literal).
  */
  regexp: e(b),
  /**
  An escape [literal](#highlight.tags.literal), for example a
  backslash escape in a string.
  */
  escape: e(b),
  /**
  A color [literal](#highlight.tags.literal).
  */
  color: e(b),
  /**
  A URL [literal](#highlight.tags.literal).
  */
  url: e(b),
  /**
  A language keyword.
  */
  keyword: p,
  /**
  The [keyword](#highlight.tags.keyword) for the self or this
  object.
  */
  self: e(p),
  /**
  The [keyword](#highlight.tags.keyword) for null.
  */
  null: e(p),
  /**
  A [keyword](#highlight.tags.keyword) denoting some atomic value.
  */
  atom: e(p),
  /**
  A [keyword](#highlight.tags.keyword) that represents a unit.
  */
  unit: e(p),
  /**
  A modifier [keyword](#highlight.tags.keyword).
  */
  modifier: e(p),
  /**
  A [keyword](#highlight.tags.keyword) that acts as an operator.
  */
  operatorKeyword: e(p),
  /**
  A control-flow related [keyword](#highlight.tags.keyword).
  */
  controlKeyword: e(p),
  /**
  A [keyword](#highlight.tags.keyword) that defines something.
  */
  definitionKeyword: e(p),
  /**
  A [keyword](#highlight.tags.keyword) related to defining or
  interfacing with modules.
  */
  moduleKeyword: e(p),
  /**
  An operator.
  */
  operator: m,
  /**
  An [operator](#highlight.tags.operator) that dereferences something.
  */
  derefOperator: e(m),
  /**
  Arithmetic-related [operator](#highlight.tags.operator).
  */
  arithmeticOperator: e(m),
  /**
  Logical [operator](#highlight.tags.operator).
  */
  logicOperator: e(m),
  /**
  Bit [operator](#highlight.tags.operator).
  */
  bitwiseOperator: e(m),
  /**
  Comparison [operator](#highlight.tags.operator).
  */
  compareOperator: e(m),
  /**
  [Operator](#highlight.tags.operator) that updates its operand.
  */
  updateOperator: e(m),
  /**
  [Operator](#highlight.tags.operator) that defines something.
  */
  definitionOperator: e(m),
  /**
  Type-related [operator](#highlight.tags.operator).
  */
  typeOperator: e(m),
  /**
  Control-flow [operator](#highlight.tags.operator).
  */
  controlOperator: e(m),
  /**
  Program or markup punctuation.
  */
  punctuation: j,
  /**
  [Punctuation](#highlight.tags.punctuation) that separates
  things.
  */
  separator: e(j),
  /**
  Bracket-style [punctuation](#highlight.tags.punctuation).
  */
  bracket: S,
  /**
  Angle [brackets](#highlight.tags.bracket) (usually `<` and `>`
  tokens).
  */
  angleBracket: e(S),
  /**
  Square [brackets](#highlight.tags.bracket) (usually `[` and `]`
  tokens).
  */
  squareBracket: e(S),
  /**
  Parentheses (usually `(` and `)` tokens). Subtag of
  [bracket](#highlight.tags.bracket).
  */
  paren: e(S),
  /**
  Braces (usually `{` and `}` tokens). Subtag of
  [bracket](#highlight.tags.bracket).
  */
  brace: e(S),
  /**
  Content, for example plain text in XML or markup documents.
  */
  content: u,
  /**
  [Content](#highlight.tags.content) that represents a heading.
  */
  heading: w,
  /**
  A level 1 [heading](#highlight.tags.heading).
  */
  heading1: e(w),
  /**
  A level 2 [heading](#highlight.tags.heading).
  */
  heading2: e(w),
  /**
  A level 3 [heading](#highlight.tags.heading).
  */
  heading3: e(w),
  /**
  A level 4 [heading](#highlight.tags.heading).
  */
  heading4: e(w),
  /**
  A level 5 [heading](#highlight.tags.heading).
  */
  heading5: e(w),
  /**
  A level 6 [heading](#highlight.tags.heading).
  */
  heading6: e(w),
  /**
  A prose separator (such as a horizontal rule).
  */
  contentSeparator: e(u),
  /**
  [Content](#highlight.tags.content) that represents a list.
  */
  list: e(u),
  /**
  [Content](#highlight.tags.content) that represents a quote.
  */
  quote: e(u),
  /**
  [Content](#highlight.tags.content) that is emphasized.
  */
  emphasis: e(u),
  /**
  [Content](#highlight.tags.content) that is styled strong.
  */
  strong: e(u),
  /**
  [Content](#highlight.tags.content) that is part of a link.
  */
  link: e(u),
  /**
  [Content](#highlight.tags.content) that is styled as code or
  monospace.
  */
  monospace: e(u),
  /**
  [Content](#highlight.tags.content) that has a strike-through
  style.
  */
  strikethrough: e(u),
  /**
  Inserted text in a change-tracking format.
  */
  inserted: e(),
  /**
  Deleted text.
  */
  deleted: e(),
  /**
  Changed text.
  */
  changed: e(),
  /**
  An invalid or unsyntactic element.
  */
  invalid: e(),
  /**
  Metadata or meta-instruction.
  */
  meta: I,
  /**
  [Metadata](#highlight.tags.meta) that applies to the entire
  document.
  */
  documentMeta: e(I),
  /**
  [Metadata](#highlight.tags.meta) that annotates or adds
  attributes to a given syntactic element.
  */
  annotation: e(I),
  /**
  Processing instruction or preprocessor directive. Subtag of
  [meta](#highlight.tags.meta).
  */
  processingInstruction: e(I),
  /**
  [Modifier](#highlight.Tag^defineModifier) that indicates that a
  given element is being defined. Expected to be used with the
  various [name](#highlight.tags.name) tags.
  */
  definition: k.defineModifier(),
  /**
  [Modifier](#highlight.Tag^defineModifier) that indicates that
  something is constant. Mostly expected to be used with
  [variable names](#highlight.tags.variableName).
  */
  constant: k.defineModifier(),
  /**
  [Modifier](#highlight.Tag^defineModifier) used to indicate that
  a [variable](#highlight.tags.variableName) or [property
  name](#highlight.tags.propertyName) is being called or defined
  as a function.
  */
  function: k.defineModifier(),
  /**
  [Modifier](#highlight.Tag^defineModifier) that can be applied to
  [names](#highlight.tags.name) to indicate that they belong to
  the language's standard environment.
  */
  standard: k.defineModifier(),
  /**
  [Modifier](#highlight.Tag^defineModifier) that indicates a given
  [names](#highlight.tags.name) is local to some scope.
  */
  local: k.defineModifier(),
  /**
  A generic variant [modifier](#highlight.Tag^defineModifier) that
  can be used to tag language-specific alternative variants of
  some common tag. It is recommended for themes to define special
  forms of at least the [string](#highlight.tags.string) and
  [variable name](#highlight.tags.variableName) tags, since those
  come up a lot.
  */
  special: k.defineModifier()
};
U([
  { tag: n.link, class: "tok-link" },
  { tag: n.heading, class: "tok-heading" },
  { tag: n.emphasis, class: "tok-emphasis" },
  { tag: n.strong, class: "tok-strong" },
  { tag: n.keyword, class: "tok-keyword" },
  { tag: n.atom, class: "tok-atom" },
  { tag: n.bool, class: "tok-bool" },
  { tag: n.url, class: "tok-url" },
  { tag: n.labelName, class: "tok-labelName" },
  { tag: n.inserted, class: "tok-inserted" },
  { tag: n.deleted, class: "tok-deleted" },
  { tag: n.literal, class: "tok-literal" },
  { tag: n.string, class: "tok-string" },
  { tag: n.number, class: "tok-number" },
  { tag: [n.regexp, n.escape, n.special(n.string)], class: "tok-string2" },
  { tag: n.variableName, class: "tok-variableName" },
  { tag: n.local(n.variableName), class: "tok-variableName tok-local" },
  { tag: n.definition(n.variableName), class: "tok-variableName tok-definition" },
  { tag: n.special(n.variableName), class: "tok-variableName2" },
  { tag: n.definition(n.propertyName), class: "tok-propertyName tok-definition" },
  { tag: n.typeName, class: "tok-typeName" },
  { tag: n.namespace, class: "tok-namespace" },
  { tag: n.className, class: "tok-className" },
  { tag: n.macroName, class: "tok-macroName" },
  { tag: n.propertyName, class: "tok-propertyName" },
  { tag: n.operator, class: "tok-operator" },
  { tag: n.comment, class: "tok-comment" },
  { tag: n.meta, class: "tok-meta" },
  { tag: n.invalid, class: "tok-invalid" },
  { tag: n.punctuation, class: "tok-punctuation" }
]);
export {
  k as Tag,
  Y as getStyleTags,
  _ as highlightTree,
  $ as styleTags,
  U as tagHighlighter,
  n as tags
};
